import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { StorageService } from '../service/storage.service';

export const authGuard: CanActivateFn = (_route, state) => {
  const storageService = inject(StorageService);
  const router = inject(Router);

  const user = storageService.getIdentity();

  if (user) {
    return true;
  }

  return router.createUrlTree(['/signin'], {
    queryParams: {
      returnUrl: state.url,
    },
  });
};
